import { useEffect, useRef, useState } from 'react';
import html2canvas from 'html2canvas';
import DesafioShareCard from './DesafioShareCard';

const IconTrophy = () => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M6 9H4a2 2 0 0 1-2-2V5h4" />
    <path d="M18 9h2a2 2 0 0 0 2-2V5h-4" />
    <path d="M12 17v4" />
    <path d="M8 21h8" />
    <path d="M6 5h12v6a6 6 0 0 1-6 6 6 6 0 0 1-6-6V5z" />
  </svg>
);
const IconShare = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
    <polyline points="16 6 12 2 8 6" />
    <line x1="12" y1="2" x2="12" y2="15" />
  </svg>
);
const IconArrow = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="5" y1="12" x2="19" y2="12" />
    <polyline points="12 5 19 12 12 19" />
  </svg>
);
const IconClose = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

export default function ModalCelebracao({ desafio, conquista, onFechar }) {
  const temParametro = !!(desafio?.parametro_pergunta_depois && desafio?.parametro_opcoes);
  const opcoes = temParametro
    ? desafio.parametro_opcoes.split(',').map(o => o.trim()).filter(Boolean)
    : [];

  // Etapa 1: coleta parametro_depois (se configurado)
  // Etapa 2: celebração com antes/depois
  const [etapa, setEtapa] = useState(temParametro ? 1 : 2);
  const [selecionado, setSelecionado] = useState(null);

  useEffect(() => {
    if (etapa === 2 && window.fbq) {
      window.fbq('trackCustom', 'DesafioConcluido', { desafio: desafio?.desafio_nome });
    }
  }, [etapa]); // eslint-disable-line react-hooks/exhaustive-deps
  const [previewUrl, setPreviewUrl] = useState(null);
  const [sharing, setSharing] = useState(false);
  const [shareError, setShareError] = useState(false);
  const shareCardRef = useRef(null);

  const handleConfirmarParametro = () => {
    if (!selecionado) return;
    setEtapa(2);
    // Passa o valor para o pai via onFechar com callback
    if (onFechar._passParametro) onFechar._passParametro(selecionado);
  };

  const handleCompartilhar = async () => {
    if (!shareCardRef.current) return;
    setSharing(true);
    setShareError(false);
    try {
      try { await document.fonts.ready; } catch {}
      await new Promise(r => setTimeout(r, 80));
      const scale = Math.min(window.devicePixelRatio || 2, 2);
      const canvas = await html2canvas(shareCardRef.current, {
        scale,
        useCORS: true,
        allowTaint: true,
        backgroundColor: '#2f2b5f',
        logging: false,
        foreignObjectRendering: false,
      });
      setPreviewUrl(canvas.toDataURL('image/png'));
    } catch (err) {
      console.error('[ModalCelebracao] html2canvas error:', err);
      // Fallback: compartilhar texto via blob quando html2canvas falha
      try {
        const texto = `Completei o desafio "${desafio?.desafio_nome}" — Clube do Eu`;
        const blob = new Blob([texto], { type: 'text/plain' });
        const url = URL.createObjectURL(blob);
        if (navigator.canShare && navigator.canShare()) {
          await navigator.share({ text: texto, title: 'Minha conquista — Clube do Eu' });
        } else {
          const link = document.createElement('a');
          link.href = url;
          link.download = 'conquista-clube-do-eu.txt';
          link.click();
        }
        URL.revokeObjectURL(url);
      } catch {
        setShareError(true);
      }
    } finally {
      setSharing(false);
    }
  };

  const handleDownload = () => {
    if (!previewUrl) return;
    const link = document.createElement('a');
    link.download = 'conquista-clube-do-eu.png';
    link.href = previewUrl;
    link.click();
  };

  const handleShare = async () => {
    if (!previewUrl) return;
    try {
      const res = await fetch(previewUrl);
      const blob = await res.blob();
      const file = new File([blob], 'conquista-clube-do-eu.png', { type: 'image/png' });
      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        await navigator.share({ files: [file], title: 'Minha conquista — Clube do Eu' });
      } else {
        handleDownload();
      }
    } catch {
      handleDownload();
    }
  };

  const parametroDepois = etapa === 2 ? selecionado : null;

  return (
    <>
      {/* Card off-screen para captura */}
      <DesafioShareCard
        desafio={desafio}
        parametroAntes={desafio?.parametro_antes}
        parametroDepois={parametroDepois}
        conquista={conquista}
        cardRef={shareCardRef}
      />

      {/* Preview overlay */}
      {previewUrl && (
        <div className="oracle-preview-backdrop" onClick={() => setPreviewUrl(null)}>
          <div className="oracle-preview-box" onClick={e => e.stopPropagation()}>
            <img src={previewUrl} alt="Card para compartilhar" className="oracle-preview-img" draggable={false} />
            <button className="btn btn-primary" style={{ width: '100%' }} onClick={handleShare}>
              Compartilhar / Salvar imagem
            </button>
            <button className="btn btn-ghost oracle-preview-close" onClick={() => setPreviewUrl(null)}>
              Fechar
            </button>
          </div>
        </div>
      )}

      {/* Modal */}
      <div className="modal-celebracao-backdrop">
        <div className="modal-celebracao-card">
          <div className="modal-celebracao-decor" />

          {/* ETAPA 1 — Coleta parametro depois */}
          {etapa === 1 && (
            <>
              <div className="modal-parametro-header" style={{ textAlign: 'center', width: '100%' }}>
                <p className="modal-parametro-supra">Você chegou lá!</p>
                <h3 className="modal-celebracao-titulo" style={{ fontSize: 22 }}>
                  {desafio?.parametro_pergunta_depois}
                </h3>
                {desafio?.parametro_label && (
                  <p className="modal-parametro-label">{desafio.parametro_label}</p>
                )}
              </div>

              <div className="modal-parametro-opcoes" style={{ width: '100%' }}>
                {opcoes.map((opcao, i) => (
                  <button
                    key={i}
                    className={`modal-parametro-opcao ${selecionado === opcao ? 'selecionado' : ''}`}
                    onClick={() => setSelecionado(opcao)}
                  >
                    {opcao}
                  </button>
                ))}
              </div>

              <div className="modal-celebracao-acoes">
                <button
                  className="btn btn-primary"
                  style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}
                  onClick={handleConfirmarParametro}
                  disabled={!selecionado}
                >
                  Ver minha evolução <IconArrow />
                </button>
              </div>
            </>
          )}

          {/* ETAPA 2 — Celebração com antes/depois */}
          {etapa === 2 && (
            <>
              <div className="modal-celebracao-icone">
                <IconTrophy />
              </div>

              <div className="modal-celebracao-texto">
                <p className="modal-celebracao-supra">Você completou o desafio</p>
                <h2 className="modal-celebracao-titulo">{desafio?.desafio_nome}</h2>
                <p className="modal-celebracao-mensagem">
                  {desafio?.duracao} dias de presença e compromisso com você mesma.
                  Cada dia foi uma escolha.
                </p>
              </div>

              {/* Antes / Depois */}
              {desafio?.parametro_antes && parametroDepois && (
                <div className="celebracao-antes-depois">
                  <p className="celebracao-parametro-label">{desafio.parametro_label}</p>
                  <div className="celebracao-antes-depois-row">
                    <div className="celebracao-col">
                      <span className="celebracao-col-supra">Antes</span>
                      <span className="celebracao-col-valor">{desafio.parametro_antes}</span>
                    </div>
                    <div className="celebracao-seta">→</div>
                    <div className="celebracao-col destaque">
                      <span className="celebracao-col-supra">Agora</span>
                      <span className="celebracao-col-valor">{parametroDepois}</span>
                    </div>
                  </div>
                </div>
              )}

              {conquista && (
                <div className="modal-celebracao-conquista">
                  <div className="modal-celebracao-conquista-icone">
                    <IconTrophy />
                  </div>
                  <div>
                    <p className="modal-celebracao-conquista-nome">{conquista.name}</p>
                    <p className="modal-celebracao-conquista-desc">{conquista.description}</p>
                  </div>
                </div>
              )}

              <div className="modal-celebracao-acoes">
                <button
                  className="btn btn-primary"
                  style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}
                  onClick={handleCompartilhar}
                  disabled={sharing}
                >
                  <IconShare />
                  {sharing ? 'Gerando imagem...' : 'Compartilhar conquista'}
                </button>
                {shareError && (
                  <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 13, textAlign: 'center', marginTop: 8, opacity: 0.7 }}>
                    Não foi possível gerar a imagem. Tente novamente.
                  </p>
                )}
                <button className="btn btn-ghost" style={{ width: '100%' }} onClick={() => onFechar(selecionado)}>
                  Continuar
                </button>
              </div>
            </>
          )}

          <button className="modal-celebracao-fechar" onClick={() => onFechar(selecionado)} aria-label="Fechar">
            <IconClose />
          </button>
        </div>
      </div>
    </>
  );
}
